import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const RfMonthlyLimitAddModalUI = ({ context, successMsg, errorList, setErrorList,
  createMode, submitted, onSubmit, onCancelClick,
  month, onMonthChange, monthError, setMonthError, monthList,
  year, onYearChange, yearError, setYearError, yearList,
  amount, onAmountChange, amountError, setAmountError, amountList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add monthly limit'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='month' label='Month'
      value={month} onChange={onMonthChange} optionList={monthList}
      error={monthError} setError={setMonthError}
    />
    <InputSelectSF type='select' name='year' label='Year'
      value={year} onChange={onYearChange} optionList={yearList}
      error={yearError} setError={setYearError}
    />
    <InputTextSF type='text' name='amount' label='Amount'
      value={amount} onChange={onAmountChange} optionList={amountList}
      error={amountError} setError={setAmountError}
    />
  </ModalFormUI>

export default RfMonthlyLimitAddModalUI
